// extracted by mini-css-extract-plugin
module.exports = {"title":"PageTitle_title__110W0","description":"PageTitle_description__aFWLM"};